import React from "react";
import { getDirectionsUrl } from "../../helpers/location";
import { logUI } from '../../api/andyliticsApi';
import * as Tools from "../../helpers/Tools";

function Covid19VaccineProviderLocations({ prov, showProviderDetails }) {

    const redirectToMap = (item) => {
        logUI("MBHWeb.UI.Covid19VaccineProviderLocations.redirectToMap", new Date(), Tools.getURLPath())
        const { locationStreet1, locationStreet2, locationCity, locationState, locationZip } = item;
        if (locationStreet1) {
            const toAddress = locationStreet2 ? `${locationStreet1}, ${locationStreet2}, ${locationCity}, ${locationState} ${locationZip}` : `${locationStreet1}, ${locationCity}, ${locationState} ${locationZip}`;
            var addressUrl = getDirectionsUrl(null, toAddress);
            if (typeof window !== 'undefined' && addressUrl) {
                window.open(addressUrl, "_blank");
            }
        }
    }

    const indexOfLocation = 0;
    const commaText = showProviderDetails ? ',' : <br />;
    const locations = prov.locations ? prov.locations.map((loc, i) => {
        return (
            <a key={i} className={loc.locationStreet1 ? "directions-link" : "no-link"} onClick={() => redirectToMap(loc)}>
                <div className="details-icon-prepend">
                    <div className="icon-col">
                        <span className="icon-address" />
                    </div>
                    <div className="details-col">
                        {!showProviderDetails &&
                            <div className="item-location__name">
                                {loc.locationName ? <span>{loc.locationName} </span>
                                    : <div className="no-data-dash">
                                        <div />
                                    </div>
                                }
                            </div>
                        }
                        <div className="item-location__address">
                            {loc.distance && showProviderDetails ? <span className="item-miles">{(loc.distance).toFixed(2)} miles - </span> : ""}
                            {loc.locationStreet1 ?
                                <div className="loc-address"><span><span className="item-street">{loc.locationStreet1}</span>{loc.locationStreet2 && <span className="item-suite">, {loc.locationStreet2}</span>}</span><span className="item-city">{commaText} {loc.locationCity}</span><span className="item-state">, {loc.locationState}</span><span className="item-zip"> {loc.locationZip}</span> </div>
                                : <div className="no-data-dash">
                                    <div />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </a>
        );
    }) : [];

    return (
        <div className={"col-12 item-location"}>
            {locations && locations.length > 0 ? locations[indexOfLocation] :
                <div className="details-icon-prepend">
                    <div className="icon-col">
                        <span className="icon-address" />
                    </div>
                    <div className="details-col">
                        <div className="no-data-dash">
                            <div />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Covid19VaccineProviderLocations;